import { lazy } from 'react'

export const LunchTime = lazy(() => import('./LunchTime'))
